export default __webpack_public_path__ + "static/media/img_step_appliance04.6af3271c.jpg";